<template>
  <div class="p_list">
        <div class="common_mbx">
      您当前的位置：
      <router-link to='/index' tag='span'>
        首页
      </router-link>
      <template v-for='(item,index) in parent'>
        <router-link to='/product' v-if='index==0' tag='span'>
           >{{item.name}}
        </router-link>
       <router-link :to='"/product/list/"+item.id' v-if='index==1' tag='span'>
           >{{item.name}}
        </router-link>
        <router-link :to='"/product/list2/"+item.id' v-if='index==3' tag='span'>
           >{{item.name}}
        </router-link>
        <!-- <router-link to='/product' v-if='index==3'>
           >{{item.name}}
        </router-link> -->
      </template>
      <!-- > 面盆洁具
      > DKING【水龙头】意大利fir -->
    </div>
    <img :src="domain+cate.litpic" class="list_banner" v-if='cate.litpic'>
    <div class="common_wrap" v-for='item in Category'>
      <p class="common_title sp">{{item.name}}</p>
      <div class="p_items clearfix" >
          <div class="p_item" v-for='child in item.child' v-if='!item.art'>
             <router-link :to="'/product/list2/'+child.id">
              <div>
                <img :src="domain+child.litpic">
              </div>
              <p>{{child.name}}</p>
              </router-link>
          </div>
          <div class="p_item" v-for='child in item.art' v-if='item.art'>
             <router-link :to="'/product/detail/'+child.id">
              <div>
                <img :src="domain+child.litpic">
              </div>
              <p>{{child.title}}</p>
              </router-link>
          </div>
      </div>
    </div>

    <div class="common_wrap" v-if='list.length>0'>
      <p class="common_title sp">{{cate.name}}</p>
      <div class="p_items clearfix" >
          <div class="p_item"  v-for='item in list'>
             <router-link :to="'/product/detail/'+item.id">
              <div>
                <img :src="domain+item.litpic">
              </div>
              <p>{{item.title}}</p>
              </router-link>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      Category:[],
      cate:'',
      domain:'',
      parent:[],
      list:[]
    }
  },
  watch:{
    '$route':function(to,from){
      this.getCategory()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getCategory()
  },
  methods:{
    getparent:function(id){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid:id
      }))
      .then(response => {
        console.log(response);
        this.parent=response.data.data
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getCategory:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid:this.$route.params.id
      }))
      .then(response => {
        console.log(response);
        this.Category=response.data.data
        this.cate = response.data.cate
        this.getparent(this.cate.id) 
        if(this.Category.length==0){
          this.getList()
        }
        //this.parent=this._routerRoot.parent;

        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getList:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid:this.$route.params.id,
        page:1,
        limit:1000
      }))
      .then(response => {
        console.log(response);
        this.list=response.data.data
        //this.cate = response.data.cate
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
  .common_mbx span{
    cursor: pointer;
  }
 .p_list{
  width: 1200px;
  margin: 0 auto;
 }
 .index_items{
  width: 1200px;
  margin: 0 auto;
 }
 .p_items{
   display: inline-flex;
  flex-wrap: wrap;
 }
 .p_item{
  width: 180px;
  text-align: center;
  margin-right: 160px;
  position: relative;
  margin-bottom: 90px;
 
 }
 .p_item:nth-child(4n){
  margin-right: 0;
 }
 .p_item a>div{
  min-height: 180px;
  position: relative;
  margin-bottom: 40px;
 }
 .p_item img{
    width: 100%;
    display: block;
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
 }
 .p_item p{
  font-size: 14px;
  color: #5d5d5d;
  min-width: 80px;
  text-align: center;
  border-radius: 4px;
  background-color: #eeeeee;
  display: inline-block;
  line-height: 30px;
  padding: 0 5px;
  word-break: break-all;
 }
 .p_item p:hover{
  background-color: #3478f7;
  color: #fff;
 }
 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .common_title.sp{
  font-size: 18px;
  color: #3478f7;
  text-align: center;
  margin-bottom: 50px;
  padding-top: 60px;
 }
 .common_title.sp:before{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #3478f7;
  position: relative;
  top: -6px;
  right: 7px;
 }
 .common_title.sp:after{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #3478f7;
  position: relative;
  top: -6px;
  left: 7px;
 }
 .index_active{
  min-width: 1300px;
 }
 .index_active img{
  width: 100%;
 }
 .hot_item{
  width: 290px;
  height: 382px;
  background-color: #fff;
  float: left;
  margin-right: 13px;
  border-radius: 4px;
  margin-bottom: 39px;
 }
 .hot_item:hover{
  position: relative;
  box-shadow: 2px 2px 20px #e4e4e4;
  top: -10px
 }
 .hot_item:nth-child(4n){
  margin-right: 0;
 }
 .hot_wrap{
  background-color: #f8f7f7;
 }
 .hotimg_wrap{
  height: 290px;
  position: relative;
 }
 .hotimg_wrap img.p{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
 }
 .hotimg_wrap .tips{
  top: 22px;
  left: 14px;
  position: absolute;
  z-index: 999
 }
 .hot_item p{
  font-size: 18px;
  color: #5d5d5d;
  padding-left: 27px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
 }
 .p_name{
  margin-bottom: 16px;
 }
 .list_banner{
  width: 100%;
 }
</style>


// WEBPACK FOOTER //
// src/components/product_list.vue